/**
 * Exactly the admin Products tab rule (Products/index.js:
 * `guruUserToken || paymentGateway === "PAGARME"`). Guru tenants always ship
 * REACT_APP_GURU_USER_TOKEN, and Stripe tenants usually keep `paymentGateway`
 * empty — treating an empty gateway as Guru made Stripe showcases load the
 * `products` collection instead of `plans`/`courses`.
 */
export function isGuruOrPagarmeTenant({ guruUserToken, paymentGateway } = {}) {
  return !!guruUserToken || paymentGateway === 'PAGARME';
}

export function getCatalogTenantKey({ guruUserToken, paymentGateway } = {}) {
  return isGuruOrPagarmeTenant({ guruUserToken, paymentGateway }) ? 'guru' : 'stripe';
}

/** Produtos visíveis na tabela Guru/Pagarme (+ IAP) da aba Produtos. */
export function isAdminProductsTabProduct(data) {
  const marketplace = data?.marketplace;
  return (
    marketplace === 'Guru Digital' ||
    marketplace === 'PAGARME' ||
    marketplace === 'IAP'
  );
}

/** Planos-pai Stripe (não as frequências filhas " | Mensal"). */
export function isAdminPlansTabPlan(data) {
  return data?.isPlanFrequency === false;
}

export function filterPlanDocsForCatalog(docs = []) {
  return docs.filter((docSnap) => isAdminPlansTabPlan(docSnap.data()));
}

export function filterProductDocsForCatalog(docs = []) {
  return docs.filter((docSnap) => isAdminProductsTabProduct(docSnap.data()));
}
